import React, { useCallback, useEffect, useState } from "react";

import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { useIntl } from "react-intl";
import { getList } from "services/api/Api";
import { saveBoard } from "services/restAPI/RestApi";

import ChartType from "./ChartType.json";
import IntlMessages from "util/IntlMessages";

import "./CircleChartSettings.less";
import { isActivePublicUser } from "../../../../util/Scripts";
import { Input, Message, Switch, Button } from "../../../BP2Components";

const CircleChartSettings = (props) => {
   const { value, columns } = props;

   const [settings, setSettings] = useState({
      ...value,
      columns: columns
   });

   const { boards } = useSelector(({ boards }) => boards);
   const { id } = useSelector(({ user }) => user);

   const { Option, OptGroup } = Select;

   const dispatch = useDispatch();

   useEffect(() => {
      setSettings({
         ...settings,
         columns: columns
      });
   }, [props]);
   const intl = useIntl();

   const handleSelect = (name, e) => {
      setSettings({ ...settings, [name]: e });
   };

   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      Message.success(intl.formatMessage({ id: "global.saved" }));
      saveBoard(boards, id);
      dispatch(setWidgetInSheetParams(settings));
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   // console.log(settings);
   // useEffect(() => {
   //    getList(settings.listId, 1, 10).then((res) => {
   //       console.log(res);
   //       if (res.data.default.columns !== undefined && res.data.default.columns !== null) {
   //          console.log(res.data.default.colums);
   //          setSettings({
   //             ...settings,
   //             columns: res.data.default.columns
   //          });
   //       }
   //    });
   // });

   const handleChangeList = useCallback(
      (e) => {
         getList(settings.listId, 1, 10).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            if (responseData.columns !== undefined && responseData.columns !== null) {
               setSettings({
                  ...settings,
                  columns: responseData.columns
               });
            }
         });
      },
      [settings]
   );

   return (
      <>
         <div className="main-container">
            <form onSubmit={handleSubmit}>
               <div className="widget-settings">
                  <div className="widget-settings__inner">
                     <label className="widget-settings__inner__label" key="title">
                        <IntlMessages id="settings.title" />:
                        <Input
                           type="title"
                           name="title"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.title}
                        />
                     </label>
                     <label className="widget-settings__inner__label" key="listId">
                        <IntlMessages id="settings.listId" />:
                        <div className="gx-ml-1">
                           <Input
                              type="text"
                              name="listId"
                              defaultValue={value.listId}
                              onChange={handleChange}
                              className="list-id-input-style"
                           />
                           <Button
                              className="gx-ml-1 change-list-id-button"
                              buttonType="primary"
                              onClick={handleChangeList}
                           >
                              <IntlMessages id="settings.changeId" />
                           </Button>
                        </div>
                     </label>
                     <label className="widget-settings__inner__label" key="iconId">
                        <IntlMessages id="settings.iconId" />:
                        <Input
                           type="iconId"
                           name="iconId"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.iconId}
                        />
                     </label>
                     <label className="widget-settings__inner__label" key="textColor">
                        <IntlMessages id="settings.textColor" />:
                        <Input
                           type="textColor"
                           name="textColor"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.textColor}
                        />
                     </label>
                     <label className="widget-settings__inner__label" key="groupColumnTechName">
                        <IntlMessages id="settings.groupColumnTechName" />:
                        <Select
                           type="groupColumnTechName"
                           name="groupColumnTechName"
                           onSelect={(e) => {
                              handleSelect("groupColumnTechName", e);
                           }}
                           style={{ width: "220px" }}
                           defaultValue={value.groupColumnTechName}
                        >
                           {settings.columns.map((column) => {
                              // console.log(column);
                              return (
                                 <Option value={column.label} name="groupColumnTechName">
                                    {column.label}
                                 </Option>
                              );
                           })}
                        </Select>
                     </label>
                     <label className="widget-settings__inner__label" key="timeColumnTechname">
                        <IntlMessages id="settings.timeColumnTechName" />:
                        <Input
                           type="timeColumnTechName"
                           name="timeColumnTechName"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.timeColumnTechName}
                        />
                     </label>

                     <label className="widget-settings__inner__label" key="profile">
                        <IntlMessages id="settings.profile" />:
                        <Input
                           type="profile"
                           name="profile"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.profile}
                        />
                     </label>

                     <label className="widget-settings__inner__label" key="timeRange">
                        <IntlMessages id="settings.timeRange" />:
                        <Input
                           type="timeRange"
                           name="timeRange"
                           onChange={handleChange}
                           style={{ width: "220px" }}
                           defaultValue={value.timeRange}
                        />
                     </label>
                     <label className="widget-settings__inner__label">
                        <IntlMessages id="settings.chartType" />:
                        <Select
                           className="chart-select"
                           onSelect={(e) => {
                              handleSelect("chartType", e);
                           }}
                           name="chartType"
                           defaultValue={value.chartType}
                        >
                           {ChartType.map((type) => (
                              <OptGroup label={type.chartType}>
                                 {type.data.map((chartData) => (
                                    <Option value={chartData.visualType} name="chartType">
                                       {chartData.visualType}
                                    </Option>
                                 ))}
                              </OptGroup>
                           ))}
                        </Select>
                     </label>
                     <label className="widget-settings__inner__label" key="legend">
                        <IntlMessages id="settings.legend" />:
                        <Switch
                           name="legend"
                           onChange={(e) => handleSwitch(e, "legend")}
                           defaultChecked={value.legend}
                        >
                           <IntlMessages id="settings.legend" />
                        </Switch>
                     </label>
                     <label className="widget-settings__inner__label" key="showSum">
                        <IntlMessages id="settings.showSum" />:
                        <Switch
                           name="showSum"
                           onChange={(e) => handleSwitch(e, "showSum")}
                           defaultChecked={value.showSum}
                        >
                           <IntlMessages id="settings.showSum" />
                        </Switch>
                     </label>
                  </div>
                  <Button key="btn" buttonType="primary" htmlType="submit">
                     <IntlMessages id="global.save" />
                  </Button>
               </div>
            </form>
         </div>
      </>
   );
};

export default CircleChartSettings;
